export default {
  typeMap: {
    1: '官方公告',
    2: '新闻动态',
    4: '干货文章',
    8: '其他内容'
  },
  selectItems: [
    { name: '全部内容', typeId: 0 },
    { name: '官方公告', typeId: 1 },
    { name: '新闻动态', typeId: 2 },
    { name: '干货文章', typeId: 4 },
    { name: '其他内容', typeId: 8 }
  ]
}
